<template>
  <div
    v-if="layoutSlot === 'default'"
    class="title-count showing"
    :style="'color: #444; border-color: #444; background-color: #44433;'"
    style="pointer-events: none;"
  >
    #
  </div>
  <div
    v-else-if="displayMode === 'number' && layoutSlot && layoutSlot.planElement"
    style="pointer-events: none; border-radius: 4px;"
    class="number-wrapper text-left showing"
    :class="{ planned: layoutSlot.planned, published: layoutSlot.showing && layoutSlot.showing.published, preview: layoutSlot.preview, 'p-sm': size === 'sm' }"
    :style="'color: ' + color + '; border-color: ' + color + '; background-color: ' + color + '33;'"
  >
    <div class="ellipsis">
      {{ layoutSlot.titleNumber }}
    </div>
  </div>
  <div
    v-else-if="displayMode === 'title' && layoutSlot && layoutSlot.planElement"
    style="border-radius: 4px;"
    :class="{ planned: layoutSlot.planned, published: layoutSlot.showing && layoutSlot.showing.published, preview: layoutSlot.preview, 'p-sm': size === 'sm' }"
    class="title-wrapper text-left showing"
    :style="'color: ' + color + '; border-color: ' + color + '; background-color: ' + color + '33;'"
  >
    <div
      v-if="layoutSlot.bookingWeekMovie"
      class="ellipsis"
    >
      {{ layoutSlot.bookingWeekMovie.movie && layoutSlot.bookingWeekMovie.movie.name || layoutSlot.titleNumber }}
    </div>
    <div
      v-else
      class="ellipsis"
    >
      {{ layoutSlot.titleNumber }}
    </div>
    <q-tooltip v-if="layoutSlot && layoutSlot.bookingWeekMovie && layoutSlot.bookingWeekMovie.movie && layoutSlot.bookingWeekMovie.movie.name">
      <div class="text-h6">
        {{ layoutSlot.bookingWeekMovie.movie.name }}
      </div>
      <div
        v-if="layoutSlot.bookingWeekMovie.movie.releaseDate"
        class="text-caption"
      >
        {{ layoutSlot.bookingWeekMovie.movie.releaseDate.i18n('date') }}
      </div>
      <showing-badge
        v-for="showingBadge in layoutSlot.bookingWeekMovie.movie.showingBadges.data"
        :key="showingBadge.id"
        :showing-badge="showingBadge"
        solid
      />
    </q-tooltip>
  </div>
  <div
    v-else-if="layoutSlot && layoutSlot.planElement"
    style="border-radius: 4px;"
    class="poster-wrapper text-left showing"
    :class="{ planned: layoutSlot.planned, published: layoutSlot.showing && layoutSlot.showing.published, preview: layoutSlot.preview, 'p-sm': size === 'sm' }"
    :style="'color: ' + color + '; border-color: ' + color + '; background-color: ' + color + '33;'"
  >
    <q-img
      v-if="layoutSlot && layoutSlot.bookingWeekMovie.movie"
      basic
      class="q-ma-none"
      :class="{ 'img-preview': layoutSlot.preview }"
      :src="layoutSlot.bookingWeekMovie.movie.posterImageSmallUrl"
    />
    <div
      class="q-px-sm q-py-xs"
      style="z-index: 5"
    >
      {{ layoutSlot.titleNumber }}
    </div>
    <q-tooltip v-if="layoutSlot && layoutSlot.bookingWeekMovie && layoutSlot.bookingWeekMovie.movie && layoutSlot.bookingWeekMovie.movie.name">
      <div class="text-h6">
        {{ layoutSlot.bookingWeekMovie.movie.name }}
      </div>
      <div
        v-if="layoutSlot.bookingWeekMovie.movie.releaseDate"
        class="text-caption"
      >
        {{ layoutSlot.bookingWeekMovie.movie.releaseDate.i18n('date') }}
      </div>
      <showing-badge
        v-for="showingBadge in layoutSlot.bookingWeekMovie.movie.showingBadges.data"
        :key="showingBadge.id"
        :showing-badge="showingBadge"
        solid
      />
    </q-tooltip>
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
export default {
  name: 'LayoutSlot',
  components: {
    ShowingBadge
  },
  props: {
    layoutSlot: {
      type: Object,
      required: false,
      default: null
    },
    displayMode: {
      type: String,
      required: false,
      default: 'number'
    },
    colorBy: {
      type: String,
      required: false,
      default: 'movie'
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },
  computed: {
    color () {
      if (this.colorBy === 'planElement') {
        return this.layoutSlot.planElement.color
      } else if (this.colorBy === 'movie') {
        return this.layoutSlot.movie?.color || this.layoutSlot.planElement.color
      } else {
        throw new Error('Unhandled ColorBy type')
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .poster-img {
    width: 45px;
    height: 67px;
  }

  .preview {
    border: dotted 2px !important;
    opacity: 0.5 !important;
    pointer-events: none;
  }

  .showing {
    border: solid 2px;
    opacity: 1;
  }

  .planned {
    border: dashed 2px;
    opacity: 0.75;
  }

  .published {
    border-width: 4px;
  }

  .poster-wrapper {
    width: 49px;
    height: 69px;
    overflow: hidden;
  }

  .title-wrapper {
    width: 75px;
    height: 30px;
    overflow: hidden;
  }
  .title-wrapper.p-sm {
    width: 45px;
    height: 30px;
    overflow: hidden;
  }
  .number-wrapper {
    text-align: center;
    width: 50px;
    height: 30px;
    overflow: hidden;
  }
  .number-wrapper.p-sm {
    text-align: center;
    width: 20px;
    height: 30px;
    overflow: hidden;
  }
  .title-wrapper div, .number-wrapper div {
    padding-top: 2px;
    padding-left: 5px;
  }

  .poster-wrapper.p-sm {
    width: 29px;
    height: 40px;
  }
</style>
